import React, { useState } from "react";
import { ReactComponent as UploadFileIcon } from "../../../imgs/icons/file-upload.svg";
import { ReactComponent as GlobeIcon } from "../../../imgs/icons/globe-02.svg";
import Modal from "../../../components/Modal";

function AddSourceModal({ onClose, steps, open }) {
  const [selectedOption, setSelectedOption] = useState("");

  const options = [
    {
      value: "website",
      label: "Website URL(s)",
      description: "One or many",
      image: <GlobeIcon className="w-16" />,
      imageSm: <GlobeIcon className="w-6 h-6" />,
    },
    {
      value: "files",
      label: "Upload Files",
      description: ".pdf, .xlsx, .docx",
      image: <UploadFileIcon className="w-16" />,
      imageSm: <UploadFileIcon className="w-6 h-6" />,
    },
    /*{
      value: "gmail",
      label: "Gmail Conversations",
      description: "Upload conversations to train",
      image: <GmailIcon className="w-16" />,
      imageSm: <GmailIcon className="w-6 h-6" />,
    },
    {
      value: "intercom",
      label: "Intercom Conversations",
      description: "Upload conversations to train",
      image: <IntercomIcon className="w-16" />,
      imageSm: <IntercomIcon className="w-6 h-6" />,
    },*/
  ];

  const goToNextStep = () => {
    if (steps[selectedOption]) {
      steps[selectedOption]();
      onClose();
    } else {
      alert("Coming soon");
    }
  };

  const actionDisabled = !selectedOption;

  return (
    <Modal
      submitLabel="Next"
      submitType="button"
      disabled={actionDisabled}
      onSubmit={goToNextStep}
      onClose={onClose}
      open={open}
      title="Add Source"
      description="Select a source to add new knowledge for your AI Support Agent."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {options.map(option => (
          <div
            key={option.value}
            className="flex sm:flex-col items-start cursor-pointer gap-2"
            onClick={() => setSelectedOption(option.value)}
          >
            <div
              className={`bg-gray-100 sm:w-full sm:h-40 rounded-lg p-4 text-center border-2 ${
                selectedOption === option.value
                  ? "border-primary"
                  : "border-gray-200"
              }`}
            >
              <div className="h-full flex items-center justify-center">
                <div className="rounded-lg bg-white flex justify-center items-center size-12 sm:size-24 mx-auto border-2">
                  {option.image}
                </div>
              </div>
            </div>

            <div className="flex justify-between items-start w-full bg-white">
              <div>
                <h3 className="text-sm font-semibold text-gray-800 mb-0">
                  {option.label}
                </h3>
                <p className="text-gray-600 text-sm">{option.description}</p>
              </div>

              {selectedOption === option.value ? (
                <label class="relative flex items-center cursor-pointer">
                  <input type="radio" name="radio" class="peer hidden" />
                  <div class="w-6 h-6 rounded-full border-8 border-primary flex items-center justify-center">
                    <div class="w-2 h-2 bg-white rounded-full"></div>
                  </div>
                </label>
              ) : (
                <label class="relative flex items-center cursor-pointer">
                  <input type="radio" name="radio" class="peer hidden" />
                  <div class="w-6 h-6 rounded-full border-2 border-gray-300 flex items-center justify-center">
                    <div class="w-2 h-2 bg-white rounded-full"></div>
                  </div>
                </label>
              )}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
}

export default AddSourceModal;
